import React, { useEffect, useRef, useState } from 'react'
import { Skeleton } from 'primereact/skeleton'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import moment from 'moment'
import Badge from '../../components/Badge/Badge'

const LogSistema = function () {
  const [loading, setLoading] = useState(false)
  const [usuariosLogado, setUsuariosLogado] = useState([])
  const userService = new UsuarioServiceAPI()

  const toast = useRef()

  const formatContratos = (ctts) => {
    let contratosFormatados = []
    ctts?.forEach((ctt) => {
      let obj = {
        ...ctt,
      }
      obj.dataEnvio = ctt?.dataEnvio
        ? moment(ctt?.dataEnvio).format('DD/MM/YYYY')
        : ''
      obj.status =
        ctt?.status == 0 ? (
          <Badge cor='#ffffff' fundo='#00a11b' label='Sucesso'></Badge>
        ) : (
          <Badge cor='#ffffff' fundo='#bd0000' label='Erro'></Badge>
        )
      contratosFormatados.push(obj)
    })

    return contratosFormatados
  }

  useEffect(() => {
    setLoading(true)
    userService.getLogsSistema().then(({ data }) => {
      setUsuariosLogado(formatContratos(data))
      setLoading(false)
    })
  }, [])

  return (
    <div>
      <Toast ref={toast} />
      {/* <h5 className='mb-6'>Envios do sistema</h5> */}

      <div className='grid'>
        <div className='card col-12'>
          {loading ? (
            <Skeleton height={300} />
          ) : (
            <DataTable
              paginator
              rows={15}
              value={usuariosLogado}
              responsiveLayout='scroll'
              emptyMessage='Nenhuma marca encontrada'
              dataKey='id'
            >
              <Column
                filter
                className='white-space-nowrap'
                field='mensagem'
                header='Mensagem'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='dataEnvio'
                header='Data envio'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='nossoNumero'
                header='Nosso número'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='idBoleto'
                header='ID Boleto'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='status'
                header='Status'
                style={{ width: 'auto' }}
              />
              <Column
                filter
                className='white-space-nowrap'
                field='idRemessa'
                header='ID Remessa'
                style={{ width: 'auto' }}
              />
            </DataTable>
          )}
        </div>
      </div>
    </div>
  )
}
export default LogSistema
